import { WebStorageStateStore } from "oidc-client-ts";

const oidcConfig = {
  authority: process.env.REACT_APP_AUTHORITY_ENDPOINT,
  userStore: new WebStorageStateStore({
    store: localStorage
  }),
  client_id: process.env.REACT_APP_CLIENT_ID,
  application_id: process.env.REACT_APP_APPLICATION_ID,
  redirect_uri: process.env.REACT_APP_PUBLIC_URL,
  post_logout_redirect_uri: process.env.REACT_APP_PUBLIC_URL,
  response_type: "code",
  scope: "openid profile offline_access " + process.env.REACT_APP_CLIENT_SCOPE,
  filterProtocolClaims: true,
  loadUserInfo: true,
  onSigninCallback: (_user) => {

    if (!!_user.state) {
      window.location.replace(_user.state);
    } else {

      window.history.replaceState(
        {},
        document.title,
        window.location.pathname
      );
    }

  },
};

const stripe = {

  publishableKey: process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY,
  redirect_uri: process.env.REACT_APP_PUBLIC_URL + '/paymentstatus',
}


export const config = {
  applicationName: "Supply Order",
  oidcConfig,
  stripe,
  termsOfServiceUrl: process.env.REACT_APP_TERMS_OF_SERVICE_URL,
  privacyPolicy: process.env.REACT_APP_PRIVACY_POLICY_URL,
  selectHubUrl: process.env.REACT_APP_SELECT_HUB_URL,
  baseUrl: '/SupplyOrder/api/order/',
  showRedirectBanner: false
 
}
